import { MdOutlineQuestionMark } from 'react-icons/md';
import ModalWrapper from '../ModalWrapper'
import { FaExclamation } from 'react-icons/fa'

function InfoModal({ open, setOpen, onContinue, loading, info = "", title, onCancel, continueText, cancelText, extraButton, className }) {

    if (!open) return null;

    return (
        <ModalWrapper
            title={title}
            onClose={() => setOpen(false)}
            className={className}
        >
            <div className="p-6 flex flex-col items-center text-white">
                <div className='w-[93px] aspect-square rounded-full flex items-center justify-center bg-[#BE9524] shadow-sm shadow-black/50'>
                    {!!onContinue ?
                        <MdOutlineQuestionMark className='text-4xl text-customGray' />
                        :
                        <FaExclamation className='text-4xl text-customGray' />
                    }
                </div>

                <p className='text-2xl text-center font-semibold mt-8'>{info}</p>

                <div className='flex items-center justify-center md:gap-10 gap-3 mt-12 w-full'>

                    <button
                        onClick={onCancel || (() => setOpen(false))}
                        className='p-[14px] bg-customDark hover:bg-customDark/80 w-full max-w-[430px] rounded-[10px] text-xl font-outfit text-center'
                    >
                        {cancelText || "Cancel"}
                    </button>

                    {!!onContinue && (
                        <button
                            disabled={loading}
                            onClick={onContinue}
                            className='p-[14px] bg-white/15 hover:bg-white/25 w-full max-w-[430px] rounded-[10px] text-xl font-outfit text-center disabled:bg-white/10 disabled:text-gray-400 disabled:cursor-not-allowed'
                        >
                            {continueText || (loading ? "Processing..." : "Continue")}
                        </button>
                    )}
                {!!extraButton && (
                    <button
                        onClick={extraButton.onClick}
                        className='p-[14px] bg-white/15 hover:bg-white/25 w-full max-w-[430px] rounded-[10px] text-xl font-outfit text-center disabled:bg-white/10 disabled:text-gray-400 disabled:cursor-not-allowed'
                    >
                        {extraButton.text}
                    </button>
                )}
                </div>
            </div>
        </ModalWrapper>
    )
}

export default InfoModal
